import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/dr-pam/ndc-institute/src/components/resources/CategoryClientSide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/dr-pam/ndc-institute/src/components/resources/ClientWrapper.tsx");
